export default "__VITE_ASSET__CtcBD6eI__"